import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css'; // Import the CSS file for styling
import PermanentDrawerLeft from './Layout.tsx';

function HomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionToken = localStorage.getItem('sessionToken');
    if (!sessionToken) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <PermanentDrawerLeft>
      <h1>Welcome to the Homepage</h1>
      <p>This is the homepage of your application.</p>
    </PermanentDrawerLeft>
  );
}

export default HomePage;
